import * as Scrivito from "scrivito"

import { ProductDeliveryTimeUpload } from "widgets/product-delivery-time-upload/ProductDeliveryTimeUpload"
import { useProductDeliveryTimeUploadModel } from "widgets/product-delivery-time-upload/model/useProductDeliveryTimeUploadModel"

import { ProductDeliveryTimeUploadWidget } from "./ProductDeliveryTimeUploadWidgetClass"
import "./styles/_product-delivery-time-upload-widget.scss"

Scrivito.provideComponent(ProductDeliveryTimeUploadWidget, ({ widget }) => {
  const model = useProductDeliveryTimeUploadModel()
  return (
    <div className="product-delivery-time-upload-widget">
      <ProductDeliveryTimeUpload
        {...model}
        fileLabel={
          <Scrivito.ContentTag content={widget} attribute="fileLabel" />
        }
        inputLabel={
          <Scrivito.ContentTag content={widget} attribute="inputLabel" />
        }
      />
    </div>
  )
})
